import React from 'react'

const CircleExclamation = function CircleExclamation ({ color, size }) {
  const sizing = size || 51
  return (
    <svg width={sizing} height={sizing} viewBox='0 0 51 51' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='25.5' cy='25.5' r='25.5' fill='white' />
      <path d='M30.5 8H21.5L22.5 30H29.5L30.5 8Z' fill={color} />
      <path d='M29.5 34H22.5V41.5H29.5V34Z' fill={color} />
    </svg>
  )
}

export default CircleExclamation
